export default "__VITE_ASSET__vL9DyIls__"